import { IState } from 'shared/store';

export const pricePerSquareSelector = (state: IState): number | null => {
  return state.offerData.priceInfo?.pricePerSquareValue || null;
};
